import { Component } from '@angular/core';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
	selector: 'app-session-expired',
	templateUrl: './session-expired.component.html',
	styleUrls: ['./session-expired.component.scss']
})
export class SessionExpiredComponent {

	constructor(public themeService: ThemeService) { }
}
